const shahrzadUrl = import.meta.env.VITE_BASE_URL
const favaUrl = 'https://srv190-apigateway.tehran.ir/'
const favaUrlSrvNo = (srvNo: number) =>
  `https://srv${srvNo}-apigateway.tehran.ir/`
const authFava =
  'https://srv190-apigateway.tehran.ir/ApiContainer.CitizenProfile.Front.RCL1/'

export const urls = {
  //Base
  LOGIN: authFava + 'api/v1/Account/login',
  REFRESH_TOKEN: shahrzadUrl + 'auth/api/v2/refresh-token',
  SIGNUP_OTP: shahrzadUrl + 'auth/api/v2/otp-signup',
  SIGNUP: shahrzadUrl + 'auth/api/v2/sign-up',
  SIGNUP_LEGAL_USER: authFava + 'api/v1/Account/enterprise/register',
  SIGNUP_LEGAL_USER_VERIFY:
    authFava + 'api/v1/Account/enterprise/register/verify',
  CHANGE_NUMBER_OTP: authFava + 'api/v1/Account/change-mobile-number/validate',
  CHANGE_NUMBER: authFava + 'api/v1/Account/change-mobile-number/set',
  CARD_LIST: favaUrl + 'ApiContainer.ABT.RCL1/api/V2/Card/ABTCardList',
  HANDSHAKE: shahrzadUrl + 'base/api/v2/handshake/:tileId',
  ABOUT_SHAHRZAD: shahrzadUrl + 'base/api/v2/about-me',
  FAQ: shahrzadUrl + 'base/api/v2/faq',
  // REGISTER:authFava+'api/v1/Account/individual/register',
  REGISTER_VERIFY: authFava + 'api/v1/Account/individual/register/verify',

  //payment
  INCREASE_AMOUNT: shahrzadUrl + 'payment/api/v2/wallet/increase',

  //transfer
  TRANSFER_AMOUNT:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api/v1/Transfer/Normal/Mobile',

  CAMPAIGN:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Campaign',

  APPLY_SHAHRZAD_CODE:
    favaUrl + 'apicontainer.pelicanclub.front.rcl1/api/v1/code/consume',
  //qr scan
  GET_GIFT_INFO:
    favaUrl + 'ApiContainer.Pelicanqr.RCL1/api-frontend/v1/Inquiry/GetInfo',

  //payment
  PAYMENT:
    favaUrl + 'ApiContainer.PelicanWallet.Front.RCL1/api/v1/Taxi/Purchase',

  SHOP_PAYMENT:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api/v1/Transfer/Normal/Applicant',

  // wallet
  CASH_OUT:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Cashout',
  TERMINALS:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Terminal',
  CASH_LAW: shahrzadUrl + 'support/api/v2/cashout',

  //referral

  GET_REFERR_CODE:
    favaUrl + 'ApiContainer.CitizenProfile.Front.RCL1/api/Profile/referers',

  DEPOSIT: favaUrl + 'ApiContainer.CitizenProfile.Front.RCL1/api/v1/Deposit',
  ADD_DEPOSIT:
    favaUrl + 'ApiContainer.CitizenProfile.Front.RCL1/api/v1/Deposit/:iban',
  PURCHASE:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/Purchase/Purchase',
  CAMPAIGN_TERMINALS:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Campaign/Terminal',

  LEVEL_FEATURES: shahrzadUrl + 'support/api/v2/level-features',

  FESTIVAL_TICKETS: shahrzadUrl + 'base/api/v1/festival-tickets',

  SET_FESTIVAL_TICKET: shahrzadUrl + 'base/api/v1/set-festival-code/:code',
  //Family Profile
  APPLICATOR_GROUPS:
    favaUrl +
    'ApiContainer.Citizenprofile.front.RCL1/api/v1/Group/applicator-groups',
  GROUPS_TITLES:
    favaUrl + 'ApiContainer.Citizenprofile.front.RCL1/api/v1/Group/types',
  GROUPS_MEMBERS:
    favaUrl +
    'ApiContainer.Citizenprofile.front.RCL1/api/v1/Group/members/:groupId',
  GROUPS_ROLES:
    favaUrl +
    'ApiContainer.Citizenprofile.front.RCL1/api/v1/Group/roles/:typeId',
  CREATE_GROUP: favaUrl + 'ApiContainer.Citizenprofile.front.RCL1/api/v1/Group',
  CREATE_USER:
    favaUrl + 'ApiContainer.Citizenprofile.front.RCL1/api/v1/Group/member',
  //ticketing
  SUPPORT_TICKETING_CATEGORY:
    favaUrl + 'ApiContainer.Ticketing.RCL1/api/v1/Tickets/TicketsType', //category

  SUPPORT_TICKETING_SUB_CATEGORY:
    favaUrl + 'ApiContainer.Ticketing.RCL1/api/v1/Tickets/SubType/:id', //sub category

  CREATE_TICKET: 'https://shahrzadpwa.tehran.ir/api/v1/Tickets/mytickets',
  SUPPORT_TICKET_LIST:
    favaUrl +
    'ApiContainer.Ticketing.RCL1/api/v1/tickets?IsAscending=false&SortBy=Id&Page=1&PageSize=50', //get list ticket

  FIRST_USER_TICKET: favaUrl + 'ApiContainer.Ticketing.RCL1/api/v1/Tickets/:id',

  NEW_MESSAGE: favaUrl + 'ApiContainer.Ticketing.RCL1/api/v1/Tickets/reply',

  GET_MESSAGE: favaUrl + 'ApiContainer.Ticketing.RCL1/api/v1/Tickets/reply/:id',

  //Vcard
  USER_INFO:
    favaUrl + 'ApiContainer.CitizenProfile.Front.RCL1/api/v1/Identity/vcard',
  USER_QR:
    favaUrl +
    'ApiContainer.CitizenProfile.Front.RCL1/api/v1/Identity/vcard/qrcode',

  // WalletBarcode
  WALLET_BARCODE:
    favaUrl + 'ApiContainer.PelicanClub.Front.RCL1/api/v1/wallet/barcode',

  GET_USERS_NAME: shahrzadUrl + 'support/api/v2/get_users_name',

  //WalletPayment
  CENTERS_LIST:
    favaUrl +
    'ApiContainer.PelicanWallet.Front.RCL1/api-frontend/v1/wallet/Terminal/User',
  RECEIVE_MONEY:
    favaUrl + 'ApiContainer.PelicanClub.Front.RCL1/api/v1/code/Purchase',
}
